import React from "react";
import { Box, Grid, MenuItem, Paper, Typography } from "@mui/material";
import { FormHandles } from "@unform/core";

import { LoadingComp } from "../../../../../shared/components/loading/Loading";
import { VForm, VTextField } from "../../../../../shared/forms";
import { IEditProposalGuaranteeData } from "../../../../../shared/services/api/proposal/ProposalEditService";

type TPartnerOption = {
	id: string;
	label: string;
};

interface GuaranteeDataTabProps {
	formRef: React.RefObject<FormHandles>;
	isLoading: boolean;
	onSubmit: (dados: IEditProposalGuaranteeData) => void;
	partnerOptions: TPartnerOption[];
}

export const GuaranteeDataTab: React.FC<GuaranteeDataTabProps> = ({ formRef, isLoading, onSubmit, partnerOptions }) => {
	return (
		<Box>
			{isLoading && <LoadingComp isopen />}
			<VForm id="formIdGuaranteeDataChange" ref={formRef} onSubmit={onSubmit} onPointerEnterCapture={''} onPointerLeaveCapture={''} placeholder={''}>
				<Box margin={0} display="flex" flexDirection="column" component={Paper} variant="elevation" elevation={0}>
					<Grid container item direction="column" padding={2} spacing={2}>
						<Grid container item direction="row" spacing={2}>
							<Grid item xs={12}>
								<Typography variant="h6" color={"primary"}>
									Dados da garantia
								</Typography>
							</Grid>

							<Grid item xs={12} md={3}>
								<VTextField fullWidth label="Origem" name="createdFrom" disabled={isLoading} select>
									<MenuItem value="web_app">Aplicação</MenuItem>
									<MenuItem value="web_service">Integração</MenuItem>
								</VTextField>
							</Grid>

							<Grid item xs={12} md={3}>
								<VTextField fullWidth label="Vínculo Empregatício" name="employmentRelationShip" disabled={isLoading} select>
									<MenuItem value="retired">Aposentado</MenuItem>
									<MenuItem value="freelance">Autônomo</MenuItem>
									<MenuItem value="entrepreneur">Empresário</MenuItem>
									<MenuItem value="student">Estudante</MenuItem>
									<MenuItem value="civil_servant">Funcionário Público</MenuItem>
									<MenuItem value="private_servant">Funcionário CLT</MenuItem>
									<MenuItem value="liberal">Liberal</MenuItem>
									<MenuItem value="rent_income">Renda Aluguéis</MenuItem>
								</VTextField>
							</Grid>

							<Grid item xs={12} md={3}>
								<VTextField fullWidth label="Estado Civil" name="maritalStatus" disabled={isLoading} select>
									<MenuItem value="single">Solteiro</MenuItem>
									<MenuItem value="married">Casado</MenuItem>
									<MenuItem value="widower">Viúvo</MenuItem>
									<MenuItem value="divorced">Divorciado</MenuItem>
									<MenuItem value="stable_union">União Estável</MenuItem>
								</VTextField>
							</Grid>

							<Grid item xs={12} md={3}>
								<VTextField fullWidth label="Parceiro" name="partnerId" disabled={isLoading} select>
									{partnerOptions.map((partner) => (
										<MenuItem key={partner.id} value={partner.id}>
											{partner.label}
										</MenuItem>
									))}
								</VTextField>
							</Grid>
						</Grid>
					</Grid>
				</Box>
			</VForm>
		</Box>
	);
};